import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ReadCustomCode } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { CustomCodeScope, customCodesQueryKey, invalidatePackagedPreviews } from './custom-codes-query-key';

export type ReorderCustomCodesParams = {
  scope: CustomCodeScope;
  /** The scope's ids in the new order (drag-and-drop result). */
  ids: string[];
};

export const reorderCustomCodes = async (
  params: ReorderCustomCodesParams,
): Promise<ReadCustomCode[]> => {
  return await tinctApi.customCodes.reorderCustomCodes(
    params.scope,
    params.ids,
  );
};

export const useReorderCustomCodes = (
  options?: Omit<
    UseMutationOptions<ReadCustomCode[], ApiError, ReorderCustomCodesParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reorderCustomCodes,
    onSuccess: (...args) => {
      // The response IS the reordered list — publish it straight to the cache.
      queryClient.setQueryData(customCodesQueryKey(args[1].scope), args[0]);
      invalidatePackagedPreviews(queryClient);
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
